import { memo } from 'react';

import { Text } from '@/components/core';
import { ConfidenceValidator, findField, NonEmptyValidator, RegexValidator } from '@/components/ui';
import {
  VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID,
  VALIDATOR_CONFIDENCE_FUNCTION_ID,
  VALIDATOR_LOGEX_FUNCTION_ID,
  VALIDATOR_REGEX_FUNCTION_ID,
} from '@/constants';
import { useModelConfigStore } from '@/store';

import { LogexValidator } from './LogexValidator';

export type ValidatorConfigurationProps = {
  fieldId: string;
  validatorId: string;
};

const IValidatorConfiguration = ({ fieldId, validatorId }: ValidatorConfigurationProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const validator = field?.validators?.find((v) => v.id === validatorId);

  if (!validator) return null;
  switch (validator.functionId) {
    case VALIDATOR_CONFIDENCE_FUNCTION_ID:
      return <ConfidenceValidator fieldId={fieldId} validatorId={validatorId} />;
    case VALIDATOR_REGEX_FUNCTION_ID:
      return <RegexValidator fieldId={fieldId} validatorId={validatorId} />;
    case VALIDATOR_LOGEX_FUNCTION_ID:
      return <LogexValidator fieldId={fieldId} validatorId={validatorId} />;
    case VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID:
      return <NonEmptyValidator fieldId={fieldId} validatorId={validatorId} />;
  }
  return <Text>Unrecognized validator</Text>;
};

export const ValidatorConfiguration = memo(IValidatorConfiguration) as typeof IValidatorConfiguration;
